export const SECTION_DETAILS_LOADING = 'SECTION_DETAILS_LOADING';
export const SECTION_DETAILS_SUCCESS = 'SECTION_DETAILS_SUCCESS';
export const SECTION_DETAILS_ERROR = 'SECTION_DETAILS_ERROR';
export const SECTION_DETAILS_CLEAR = 'SECTION_DETAILS_CLEAR';
